import ProductList from "../components/product/ProductList";
import Toolbar from "../containers/Header/Toolbar/Toolbar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Loader from "../components/Loader";
import HeroSlider from "../components/Slider/HeroSlider";
import FeaturedCategories from "../components/category/FeaturedCategories";

import axios from "../utils/axiosInstance";
import "./Home.css";

import Footer from "../containers/Footer/Footer";

import useDynamicTabTitle from "../useDynamicTabTitle";
import BrandRecyclerview from "../components/layout/ScrollView/BrandRecyclerview";

const Home = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [bannerImages, setBannerImages] = useState([]);
  const [campaign, setCampaign] = useState(null); // 👈 کمپین
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const showLogin = searchParams.get("login") === "true";

  useDynamicTabTitle("");

  // 📦 گرفتن داده‌ها
  const fetchData = async () => {
    try {
      setLoading(true);
      const [categoryRes, brandRes, productRes, sliderRes, campaignRes] =
        await Promise.all([
          axios.get("/categories/root"),
          axios.get("/brands?limit=9"),
          axios.get(`/products?page=${page}&limit=12&random=true`),
          axios.get("/site-content", { params: { type: "slider" } }),
          axios.get("/site-content", { params: { type: "campaign" } }), // 👈 کمپین‌ها
        ]);

      
      setCategories(categoryRes.data.rootCategories || []);
      setBrands(brandRes.data.data || []);
      setProducts(productRes.data.products || []);
      setTotalPages(productRes.data.totalPages || 1);
      // setBannerImages(sliderRes.data.items || []);

      // 👇 فقط اولین کمپین فعال را نمایش بده
      const activeCampaign =
        campaignRes.data.items?.find((item) => item.status === "active") || null;
      const activeBanners =
        sliderRes.data.items?.filter((item) => item.status === "active") || [];
      setBannerImages(activeBanners);


    } catch (err) {
      console.error("❌ Error loading data:", err);
      setError("Error loading data!");
    } finally {
      setLoading(false);
    }
  };
const visit = async () => {
    try {
      axios.post("/visit");
      console.log("visit recorded");
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchData();
      visit();
  }, [page]);

  const handleSelectCategory = (cat) => {
    navigate(`/category/${cat._id}`);
  };

  const handleSelectBrand = (brand) => {
    navigate(`/brands/${brand._id}`);
  };

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setPage(newPage);
  };


  if (loading) return <div className="p-3"><Loader/></div>;
  if (error) return <div className="p-3 text-danger">{error}</div>;

  return (
    <>
      {/* 🔹 کمپین بنر بالای Toolbar */}
      {campaign && (
        <div className="w-100">
          <a href={campaign.link} className="d-block">
            <img
              src={campaign.image}
              alt={campaign.title}
              className="img-fluid w-100"
              style={{
                maxHeight: "70px",
                objectFit: "cover",
                cursor: "pointer",
              }}
            />
          </a>
        </div>
      )}

      {/* Toolbar */}
      <Toolbar forceLogin={showLogin} />

      {/* Hero Slider */}
      <HeroSlider images={bannerImages} interval={5000} />

      {/* دسته‌ها، برندها و محصولات */}
      <div className="container-fluid mt-4">
        <div className="d-flex flex-column align-items-md-center mb-4">
          <FeaturedCategories
            categories={categories}
            onSelect={handleSelectCategory}
          />
          <BrandRecyclerview items={brands} onItemClick={handleSelectBrand} />
        </div>

        <div className="ms-0 ms-lg-5 col-12 col-lg-11">
          <ProductList products={products} />
        </div>

        {/* pagination */}
        <div className="d-flex justify-content-center align-items-center mt-4 mb-5">
          <button
            className="btn btn-outline-secondary me-2"
            onClick={() => handlePageChange(page - 1)}
            disabled={page === 1}
          >
            ‹ Prev
          </button>
          <span className="mx-2">
            Page {page} of {totalPages}
          </span>
          <button
            className="btn btn-outline-secondary ms-2"
            onClick={() => handlePageChange(page + 1)}
            disabled={page === totalPages}
          >
            Next ›
          </button>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Home;

{
  /* <div className="container py-4">
        <DealBanner />
        <FileInput
          bsize="2"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
        />
        <CategoryList categories={categories} />
        <h3 className="mt-5 mb-3">Featured Products</h3>
        <ProductList products={products} />
      </div> */
}
// const Home = ({ products }) => {
//   return (
//     <div className="App bg-white" dir="ltr">
//       {/* <main className="mt-5">
//         <ProductList products={dummyProducts} />
//       </main> */}
//       <Toolbar />
//       <ProductList products={products} />
//       {/* <RelativeLayout
//             width="match-parent"
//             height="100px"
//             xgravity="center"
//             ygravity="center"
//             padding="p-4"
//             gap="1rem"
//           >
//             <div className="position-absolute" style={{ top: "0", left: "0" }}>
//               گوشه بالا چپ
//             </div>
//             <div
//               className="position-absolute"
//               style={{ bottom: "10px", right: "10px" }}
//             >
//               پایین سمت راست
//             </div>
//           </RelativeLayout> */}

//       {/* <ScrollView
//             height="300px"
//             autoScroll="none"
//             direction="vertical"
//             fadeEdges={true}
//             showScrollButton={true}
//             className="bg-light rounded shadow"
//           >
//             <div style={{ height: "900px", padding: "1rem" }}>
//               <p>یه عالمه متن...</p>
//               <p>اسکرول‌کن...</p>
//               <p>ببین دکمه پایین هست 😎</p>
//             </div>
//           </ScrollView> */}
//       {/* <HorizontalSwipeScroll>
//             {[...Array(10)].map((_, i) => (
//               <div
//                 key={i}
//                 style={{
//                   minWidth: "150px",
//                   height: "100px",
//                   background: "#ddd",
//                   borderRadius: "8px",
//                   flexShrink: 0,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 آیتم {i + 1}
//               </div>
//             ))}
//           </HorizontalSwipeScroll>
//           <HorizontalRecyclerview
//             items={[
//               { id: 1, label: "آیتم ۱" },
//               { id: 2, label: "آیتم ۲" },
//             ]}
//             renderItem={(item) => <div>{item.label}</div>}
//             onItemClick={(item) => console.log("کلیک شد:", item)}
//           /> */}

//       {/* <HorizontalScroll height="200px">
//             {[...Array(10)].map((_, i) => (
//               <div
//                 key={i}
//                 style={{
//                   minWidth: "150px",
//                   background: "#eee",
//                   padding: "1rem",
//                   borderRadius: "8px",
//                 }}
//               >
//                 آیتم {i + 1}
//               </div>
//             ))}
//           </HorizontalScroll> */}

//       <div style={{ marginTop: "60px" }} />
//     </div>
//   );
// };

// export default Home;










